// import React from 'react'
import {
  SAVE_INVOICE_SUCCESS,
  REVIEW_INVOICE_EDIT_SUCCESS,
  REVIEW_INVOICE_EDIT_SEND_SUCCESS,
  SAVE_INVOICE_FAILED,
  UPDATE_INVOICE_FAILED,
  CLOSE_INVOICE_REVIEW_SNACKBAR,
  SAVE_AND_SEND_INVOICE_SUCCESS,
  SAVE_AND_SEND_INVOICE_PDF,
  SAVE_INVOICE_DRAFT,
  GENERATE_INVOICE_PDF_SUCCESS,
  GENERATE_INVOICE_PDF_FAILED,
  INVOKE_EXPENSE_REMINDER,
  CANCEL_EXPENSE_REMINDER,
  SET_INVOICE_ATTACHMENTS,
  REMOVE_INVOICE_ATTACHMENTS,
  NAVIGATE_TO_UPDATE_BANK_INFO,
  GO_TO_REVIEW,
  LOCATION_CHANGE,
  GET_ATTACHED_JOURNAL_PDF_DATA
} from '../constants'

const invoiceReview = (
  state = {
    apiSuccess: false,
    apiSendSuccess: false,
    apiFailed: false,
    limitExceedError: false,
    showSpinner: false,
    isSaveAndSend: false,
    isSaveInvoiceDraft: false,
    isGenerateInvoice: false,
    invoice_id: 0,
    isExpenseReminder: false,
    attachments: [],
    isNavigateToUpdateBankInfo: false,
    formValues: null,
    attachedJournalPdfData: null
  },
  action
) => {
  switch (action.type) {
    case SAVE_AND_SEND_INVOICE_SUCCESS:
      return Object.assign({}, state, {
        apiSuccess: false,
        invoice_id: action.result,
        isSaveInvoiceDraft: false,
        isSaveAndSend: false,
        showSpinner: true,
        isGenerateInvoice: true
      })

    case LOCATION_CHANGE:
      return Object.assign({}, state, { apiSuccess: false })

    case SAVE_INVOICE_SUCCESS:
      return Object.assign({}, state, {
        apiSuccess: true,
        invoice_id: action.result,
        isSaveInvoiceDraft: true,
        isSaveAndSend: false,
        showSpinner: false,
        isGenerateInvoice: false,
        attachments: [],
        attachedJournalPdfData: null
      })

    case REVIEW_INVOICE_EDIT_SUCCESS:
      return Object.assign({}, state, {
        apiSuccess: true,
        showSpinner: false,
        isSaveInvoiceDraft: true,
        isSaveAndSend: false,
        isGenerateInvoice: false
      })

    case REVIEW_INVOICE_EDIT_SEND_SUCCESS:
      return Object.assign({}, state, {
        apiSuccess: false,
        showSpinner: true,
        isSaveInvoiceDraft: false,
        isSaveAndSend: true,
        isGenerateInvoice: true
      })

    case SAVE_INVOICE_FAILED:
      return Object.assign({}, state, {
        apiSuccess: false,
        invoice_id: 0,
        isSaveInvoiceDraft: false,
        isSaveAndSend: false,
        showSpinner: false,
        isGenerateInvoice: false,
        apiFailed: true,
        attachments: [],
        attachedJournalPdfData: null
      })

    case UPDATE_INVOICE_FAILED:
      return Object.assign({}, state, {
        limitExceedError: true
      })

    case INVOKE_EXPENSE_REMINDER:
      return Object.assign({}, state, {
        isExpenseReminder: true
      })

    case CANCEL_EXPENSE_REMINDER:
      return Object.assign({}, state, {
        isExpenseReminder: false
      })

    case SET_INVOICE_ATTACHMENTS:
      return Object.assign(
        {},
        { ...state },
        {
          attachments: action.attachments
        }
      )
    case GET_ATTACHED_JOURNAL_PDF_DATA:
      return Object.assign(
        {},
        { ...state },
        {
          attachedJournalPdfData: action.data
        }
      )

    case REMOVE_INVOICE_ATTACHMENTS:
      return Object.assign(
        {},
        { ...state },
        {
          attachments: []
        }
      )

    case CLOSE_INVOICE_REVIEW_SNACKBAR:
      return Object.assign({}, state, {
        apiSuccess: false,
        apiSendSuccess: false,
        apiFailed: false,
        showSpinner: false,
        isSaveAndSend: false,
        isSaveInvoiceDraft: false,
        isGenerateInvoice: false,
        invoice_id: 0,
        limitExceedError: false,
        isNavigateToUpdateBankInfo: false
      })

    case SAVE_INVOICE_DRAFT:
      return Object.assign({}, state, {
        isSaveInvoiceDraft: true,
        isExpenseReminder: false
      })

    case SAVE_AND_SEND_INVOICE_PDF:
      return Object.assign({}, state, {
        showSpinner: false,
        isSaveAndSend: true,
        isExpenseReminder: false
      })

    case GENERATE_INVOICE_PDF_SUCCESS:
      return Object.assign({}, state, {
        apiSendSuccess: true,
        showSpinner: true,
        isGenerateInvoice: false,
        attachments: []
      })

    case GENERATE_INVOICE_PDF_FAILED:
      return Object.assign({}, state, {
        showSpinner: false,
        isGenerateInvoice: false,
        apiFailed: true,
        attachments: [],
        attachedJournalPdfData: null
      })

    case NAVIGATE_TO_UPDATE_BANK_INFO:
      return Object.assign({}, state, {
        isNavigateToUpdateBankInfo: true
      })

    case GO_TO_REVIEW:
      return Object.assign({}, state, {
        formValues: action.formValues
      })

    default:
      return state
  }
}

export default invoiceReview
